__webpack_require__.p = "/khaidem-sandip-portfolio/";